<script setup lang="ts">
defineProps<{
  title: string;
  total: number;
  to: string;
}>();
</script>

<template>
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-2">
      <h2 class="text-lg font-bold text-gray-900">{{ title }}</h2>
      <span class="text-sm text-gray-400">({{ total }})</span>
    </div>
    <NuxtLink
      :to="to"
      class="text-sm text-main font-medium hover:underline flex items-center gap-1"
    >
      Voir tout <UIcon name="i-lucide-arrow-right" class="size-3.5" />
    </NuxtLink>
  </div>
</template>
